import { fullscreenLoader } from '../../../core/components/Loader/Page/PageLoader';
import { lazyLoad } from '../../../core/utils/loadable';

export default lazyLoad({
  importFn: () => import('./index'),
  fallback: fullscreenLoader,
});
